import * as React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { GuestGuard } from '@src/components';
import { DynamicLogo } from '@src/components/core/logo';

export default function AuthLayout({ children }) {
  return (
    <GuestGuard>
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', lg: '1fr 800px' }, minHeight: '100vh' }}>
        <Box
          sx={{
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'var(--mui-palette-background-level1)',
            display: { xs: 'none', lg: 'flex' },
            flexDirection: 'column',
            p: 3,
          }}
        >
          <Stack spacing={4} sx={{ maxWidth: '700px', alignItems: 'center' }}>
            {/* Logo */}
            <DynamicLogo height="64px" width="auto" />

            {/* Welcome Text */}
            <Stack spacing={1} textAlign="center">
              <Typography variant="h4">Welcome to Lead Gurus</Typography>
              <Typography variant="h6" fontWeight="medium" color="text.primary">
                Home Improvement's Most Innovative Lead Gen Agency
              </Typography>
              <Typography color="text.secondary">
                Experience seamless access to your campaign performance, lead analytics, and growth tools—all in one place.
              </Typography>
            </Stack>
          </Stack>
        </Box>

        {/* Right side login panel */}
        <Box sx={{ boxShadow: 'var(--mui-shadows-8)', display: 'flex', flexDirection: 'column' }}>
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'column',
              flex: '1 1 auto',
              justifyContent: 'center',
              p: 3,
            }}
          >
            <Box sx={{ maxWidth: '420px', width: '100%' }}>
              {/* Optional smaller logo above login */}
              <Box
                component="img"
                src="/logo-icon.svg"
                alt="Lead Gurus"
                sx={{ height: 48, mx: 'auto', mb: 3, display: { xs: 'block', lg: 'none' } }}
              />
              {children}
            </Box>
          </Box>
        </Box>
      </Box>
    </GuestGuard>
  );
}
